import { filter } from 'lodash';

const getAvailableVariants = (variants, answers) => {
  let availableVariants = filter(variants, answers);
  return availableVariants;
};

const getAvailableOptions = (variants, productOptions) => {
  let options = {};

  productOptions.forEach((option) => {
    options[`option${option.position}`] = [];
  });

  variants.forEach((variant) => {
    productOptions.forEach((option) => {
      options[`option${option.position}`].push(variant[`option${option.position}`]);
    });
  });

  Object.keys(options).map((group) => {
    options[group] = Array.from(new Set(options[group]));
  });
  return options;
};

const getWinnerVariant = (variants, answers) => {
  let variant = filter(variants, answers);
  return variant.length > 0 ? variant[0] : null;
};

export const variantsReducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        variants: action.variants,
        available_variants: action.variants,
        options: action.options,
        available_options: getAvailableOptions(action.variants, action.options),
      };

    case 'UPDATE_OPTION':
      var answers = { ...state.answers };
      if (Object.keys(state.answers).includes(action.option) && state.answers[action.option] === action.value) {
        delete answers[action.option];
      } else {
        answers[action.option] = action.value;
      }
      let available_variants = getAvailableVariants(state.variants, answers);

      return {
        ...state,
        answers,
        available_variants,
        available_options: getAvailableOptions(available_variants, state.options),
        winning_variant: Object.keys(answers).length === state.options.length ? getWinnerVariant(available_variants, answers) : null,
      };

    case 'SELECT_VARIANT':
      var answers = { ...state.answers };
      Object.keys(action.variant)
        .filter((key) => key !== 'options')
        .filter((key) => key.includes('option') && Boolean(action.variant[key]))
        .forEach((key) => {
          answers[key] = action.variant[key];
        });
      return { ...state, answers };
  }
};
